import { gql } from 'apollo-boost'

const SET_USER = gql`
  mutation setUser($user: User!) {
    setUser(user: $user) @client
  }
`

export default SET_USER
